import { useTranslation } from "@sagot/i18n";
import { cn, Icon } from "@sagot/ui";
import { problemCountLabel, problemText, type Problem } from "../problem-model";

interface ProblemBadgeProps {
  problems: readonly Problem[];
  className?: string;
}

/** "2 problems" with a warning icon, on the header of a path that has some; its tooltip lists them (text, so colour is not the only signal). */
export function ProblemBadge({ problems, className }: ProblemBadgeProps) {
  const { t } = useTranslation();
  if (problems.length === 0) return null;
  const unique = [...new Set(problems.map((problem) => problemText(problem, t)))];
  return (
    <span
      className={cn("inline-flex shrink-0 items-center gap-1 rounded-pill border border-warning bg-warning-soft px-2 py-0.5 text-[11px] font-semibold text-warning", className)}
      title={unique.join("\n")}
      data-testid="path-problems"
    >
      <Icon name="alert-triangle" className="size-3" />
      {problemCountLabel(problems.length, t)}
    </span>
  );
}
